import React, { useEffect, useMemo, useRef, useState } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { Clipboard2Pulse, PencilSquare, Trash } from "react-bootstrap-icons";
import DataTable from "react-data-table-component";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  addValidationError,
  handlePreauthorizationDiagnosis,
  clearValidationErrors,
  handleFillStepData,
} from "../config/claimSlice";
import {
  handleAddLabTest,
  handleDeleteLabTest,
  removeValidationError,
} from "features/preauthorization/config/preauthorizationSlice";
import {
  GetAllClaimPreAuthAllList,
  GetMorphologyCodeDescription,
  GetServiceCodeDescription,
  GetSearchLabCode,
} from "features/preauthorization/config/preauthorizationApi";
import moment from "moment";
import DiagnosisMorphologySelect from "features/preauthorization/components/DiagnosisMorphologySelect";
import LabTestCodeDescription from "features/preauthorization/components/LabTestCodeDescription";
import DiagnosisCodeSelect from "features/preauthorization/components/DiagnosisCode Select";
import WizardModal from "components/wizard/WizardModal";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import IconButton from "components/common/IconButton";
import { useLocation, useParams } from "react-router-dom";
import EditDiagnosisModal from "./EditDiagnosisModal.js";
import { conditionOnsetList } from "../utils";
const ClaimDiagnosisRequest = ({
  data,
  control,
  watch,
  setValue,
  currentStep,
  age,
}) => {
  const dispatch = useDispatch();
  const { conditionOnset, diagnosisiList, labTestList, accidentType } =
    useSelector((state) => state.preauthorization);
  const {
    preauthorizationDiagnosis,
    claimRequestData: claimData,
    stepFormData,
    viewClaimInfo,
    practitionerListAdded,
  } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );

  const status = viewClaimInfo?.claim_status;
  const payloadClaim = viewClaimInfo?.payload_json;
  const payloadService = Object.values(payloadClaim?.prd_ser || {});

  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const claimType = params.get("claim_type");

  const isDisabled =
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "ready to submit" ||
    status?.toLowerCase() === "rejected" ||
    status?.toLowerCase() === "in process" ||
    status?.toLowerCase() === "validation error" ||
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "cancelled" ||
    status?.toLowerCase() === "no response" ||
    status?.toLowerCase() === "nores";

  const [showTypeError, setShowTypeError] = useState(false);
  const [morphologyData, setMorphologyData] = useState(null);
  const [showDiagnosisModal, setShowDiagnosisModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const claimReq = claimData?.entry?.find(
    (e) => e?.resource?.resourceType === "Claim",
  )?.resource;

  const morphologyCode = useMemo(
    () =>
      claimReq?.supportingInfo?.find(
        (item) => item?.category?.coding?.[0]?.code === "morphology",
      )?.code?.coding[0]?.code || payloadClaim?.sup_info?.["25"]?.morplgy?.code,
    [claimReq?.supportingInfo, payloadClaim?.sup_info],
  );

  const diagnosises = useMemo(
    () => [
      ...(claimReq?.diagnosis || []),
      ...Object.values(payloadClaim?.diag || {}).map((diag) => ({
        diagnosisCodeableConcept: { coding: [{ code: diag.diag_code }] },
        type: [{ coding: [{ code: diag.diag_typ }] }],
        extension: [
          {
            valueCodeableConcept: { coding: [{ code: diag.diag_onset || "" }] },
          },
        ],
        onAdmission: { coding: [{ code: diag.on_adms || "" }] },
      })),
    ],
    [claimReq?.diagnosis, payloadClaim?.diag],
  );

  const supportingInfo = claimReq?.supportingInfo || [];

  const hasProcessedDiagnoses = useRef(false);
  const hasProcessedLabTests = useRef(false);

  useEffect(() => {
    const fetchMorphology = async () => {
      if (!morphologyCode) return;

      try {
        const response = await dispatch(
          GetMorphologyCodeDescription({ morph_code: morphologyCode }),
        ).unwrap();
        const data = response?.data?.Morphology_Code?.[0];
        setMorphologyData(data);
        dispatch(handleFillStepData({ check: "morphology", value: data }));
        setValue("diagnosis_morphology", data);
      } catch (error) {
        console.error("Failed to fetch morphology:", error);
      }
    };

    fetchMorphology();
  }, [morphologyCode, dispatch, setValue]);

  useEffect(() => {
    dispatch(
      handleFillStepData({
        check: "accident",
        value: Boolean(claimReq?.accident || payloadClaim?.accident_date),
      }),
    );
    dispatch(
      handleFillStepData({
        check: "accident_date",
        value: claimReq?.accident?.date || payloadClaim?.accident_date,
      }),
    );
    dispatch(
      handleFillStepData({
        check: "accident_type",
        value: accidentType?.find(
          (item) =>
            item?.accdnttype_code ===
            (claimReq?.accident?.type?.coding?.[0]?.code ||
              payloadClaim?.accident_type),
        ),
      }),
    );
    dispatch(
      handleFillStepData({
        check: "address",
        value:
          claimReq?.accident?.locationAddress?.text ||
          payloadClaim?.accident_address ||
          "",
      }),
    );
  }, [claimReq, payloadClaim, accidentType, dispatch]);

  useEffect(() => {
    const noDiagnosis = !diagnosisiList || diagnosisiList.length === 0;
    const noAccidentType = !accidentType;

    if (noDiagnosis || noAccidentType) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, []);

  useEffect(() => {
    console.log({
      showDiagnosisModal,
      diagnosisesLength: diagnosises?.length,
      preauthorizationDiagnosisLength: preauthorizationDiagnosis?.length,
      diagnosises,
      preauthorizationDiagnosis,
    });

    if (
      hasProcessedDiagnoses.current ||
      showDiagnosisModal ||
      !diagnosises?.length
    ) {
      return;
    }

    const fetchAndAdd = async () => {
      try {
        const uniqueCodes = new Set();
        const uniqueEntries = new Map();

        diagnosises.forEach((entry) => {
          const code =
            entry?.diagnosisCodeableConcept?.coding?.[0]?.code ||
            entry?.diag_code;
          const type = entry?.type?.[0]?.coding?.[0]?.code || entry?.diag_typ;
          const onAdmissionCode =
            entry?.onAdmission?.coding?.[0]?.code || entry?.on_adms || "";
          const normalizedOnAdmission = onAdmissionCode
            ? onAdmissionCode.toLowerCase()
            : "";
          const conditionOnsetCodeRaw =
            entry?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.code ||
            entry?.diag_onset ||
            "";

          let conditionOnsetCode = "NR";
          const safeRawOnset = String(conditionOnsetCodeRaw || "")
            .trim()
            .toUpperCase();

          if (conditionOnsetList.includes(safeRawOnset)) {
            conditionOnsetCode = safeRawOnset;
          } else {
            const matchedOnset = conditionOnset?.find(
              (c) =>
                String(c.condonset_code || "")
                  .trim()
                  .toUpperCase() === safeRawOnset ||
                String(c.condonset_name || "")
                  .trim()
                  .toUpperCase() === safeRawOnset,
            );
            if (matchedOnset?.condonset_code) {
              const matchedCode = String(matchedOnset.condonset_code)
                .trim()
                .toUpperCase();
              if (conditionOnsetList.includes(matchedCode)) {
                conditionOnsetCode = matchedCode;
              }
            }
          }

          const isValidAdmission = ["y", "n", "u"].includes(
            normalizedOnAdmission,
          );

          console.log({ code, type, onAdmissionCode, conditionOnsetCode });

          if (!code || !type) return;

          const key = `${code}|${type}`;
          if (!uniqueEntries.has(key)) {
            uniqueEntries.set(key, {
              ...entry,
              normalizedOnAdmission,
              conditionOnsetCode,
            });
            uniqueCodes.add(code);
          }
        });

        const descriptionPromises = Array.from(uniqueCodes).map(
          async (code) => {
            const res = await dispatch(
              GetServiceCodeDescription({ diag_code: code }),
            ).unwrap();
            const data = res?.data?.Diagnosis_code?.[0] || {};
            return { code, data };
          },
        );

        const descs = await Promise.all(descriptionPromises);
        const codeToData = new Map(descs.map(({ code, data }) => [code, data]));

        for (const [, entry] of uniqueEntries) {
          const diagnosisCode =
            entry?.diagnosisCodeableConcept?.coding?.[0]?.code ||
            entry?.diag_code;
          const diagnosisType =
            entry?.type?.[0]?.coding?.[0]?.code || entry?.diag_typ;
          const onAdmissionCode = (
            entry?.onAdmission?.coding?.[0]?.code ||
            entry?.on_adms ||
            ""
          ).toLowerCase();
          const conditionOnsetCodeRaw2 =
            entry?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.code ||
            entry?.diag_onset ||
            "";

          let conditionOnsetCode = "NR";
          const safeRawOnset2 = String(conditionOnsetCodeRaw2 || "")
            .trim()
            .toUpperCase();

          if (conditionOnsetList.includes(safeRawOnset2)) {
            conditionOnsetCode = safeRawOnset2;
          } else {
            const matchedOnset2 = conditionOnset?.find(
              (c) =>
                String(c.condonset_code || "")
                  .trim()
                  .toUpperCase() === safeRawOnset2 ||
                String(c.condonset_name || "")
                  .trim()
                  .toUpperCase() === safeRawOnset2,
            );
            if (matchedOnset2?.condonset_code) {
              const matchedCode2 = String(matchedOnset2.condonset_code)
                .trim()
                .toUpperCase();
              if (conditionOnsetList.includes(matchedCode2)) {
                conditionOnsetCode = matchedCode2;
              }
            }
          }

          const exists = preauthorizationDiagnosis.some(
            (d) => d.code === diagnosisCode && d.type === diagnosisType,
          );
          if (exists) continue;

          const data = codeToData.get(diagnosisCode) || {};

          dispatch(
            handlePreauthorizationDiagnosis({
              type: "add",
              payload: {
                id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                date: moment().format("DD-MM-YYYY"),
                type: diagnosisType,
                code: diagnosisCode,
                description: data?.icd_description || "",
                valid: data?.valid,
                effective_from: data?.effective_from,
                inactive: data?.inactive,
                reactivated: data?.reactivated,
                sex: data?.sex,
                Stype: data?.Stype,
                AgeL: data?.AgeL,
                AgeH: data?.AgeH,
                Atype: data?.Atype,
                RDiag: data?.RDiag,
                Morph_Code: data?.Morph_Code,
                RTA_diag: data?.RTA_diag,
                concept_change: data?.concept_change,
                UnacceptPDx: data?.UnacceptPDx,
                condition_onset: conditionOnsetCode,
                onAdmission: onAdmissionCode,
              },
            }),
          );
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Diagnosis loading failed:", error);
        }
      }
    };

    fetchAndAdd();
    hasProcessedDiagnoses.current = true;
  }, [dispatch, diagnosises, showDiagnosisModal, preauthorizationDiagnosis]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchAndAddLabTests = async () => {
      try {
        const labTests = (supportingInfo || []).filter((info) =>
          info.category?.coding?.some((c) => c.code === "lab-test"),
        );

        const uniqueTests = new Map();

        labTests.forEach((test) => {
          const loincCode = test.code?.coding?.[0]?.code;
          if (loincCode) {
            uniqueTests.set(loincCode, test);
          }
        });

        const labPromises = Array.from(uniqueTests.keys()).map(
          async (loincCode) => {
            const response = await dispatch(
              GetSearchLabCode({
                labcde_id: loincCode,
                signal: controller.signal,
              }),
            ).unwrap();
            const labData = response?.data?.lab_codes?.[0] || {};
            return {
              loincCode,
              description: labData?.loinc_description || "",
              loinc_uom: labData?.loinc_uom || "",
            };
          },
        );

        const labs = await Promise.all(labPromises);

        for (const [loincCode, test] of uniqueTests) {
          const alreadyExists = labTestList.some(
            (lab) => lab.lab_test_code?.loinc_code === loincCode,
          );
          if (alreadyExists) continue;

          const labInfo = labs.find((l) => l.loincCode === loincCode) || {};
          dispatch(
            handleAddLabTest({
              type: "ADDLABTEST",
              payload: {
                id: crypto.randomUUID(),
                lab_test_code: {
                  loinc_code: loincCode,
                  loinc_description: labInfo.description || "",
                  loinc_uom:
                    test.valueQuantity?.code || labInfo.loinc_uom || "",
                },
                quantity: test.valueQuantity?.value || "",
              },
            }),
          );
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Lab test loading failed:", error);
        }
      }
    };

    if (
      Array.isArray(supportingInfo) &&
      supportingInfo.length > 0 &&
      !hasProcessedLabTests.current &&
      labTestList.length === 0
    ) {
      fetchAndAddLabTests();
      hasProcessedLabTests.current = true;
    }

    return () => {
      controller.abort();
    };
  }, [supportingInfo, dispatch, labTestList]);

  const { accident = false, accidentData = {} } = data || {};

  const onAdmissionOptions = [
    { value: "y", label: "Yes" },
    { value: "n", label: "No" },
    { value: "u", label: "Unknown" },
  ];

  const deleteDiagnosis = (row) => {
    dispatch(
      handlePreauthorizationDiagnosis({
        type: "delete",
        payload: { id: row?.id },
      }),
    );
  };

  const handleFieldChange = (value, id, type) => {
    if (type === "type" && value === "principal") {
      const diagnosis = preauthorizationDiagnosis.find((d) => d.id === id);
      if (diagnosis?.code === "Y96") {
        setShowTypeError(true);
        return;
      }
    }

    dispatch(
      handlePreauthorizationDiagnosis({
        type: "update",
        payload: { id, field: type, value },
      }),
    );
  };

  const handleAddLab = () => {
    if (!watch("lab_test_code")) {
      dispatch(
        addValidationError({
          field: "Lab Test Code Description",
          message: "Lab Test Code Description is required",
        }),
      );
      return;
    } else {
      dispatch(removeValidationError("Lab Test Code Description"));
    }

    if (!watch("quantity")) {
      dispatch(
        addValidationError({
          field: "Lab Test Quantity",
          message: "Lab Test Quantity is required",
        }),
      );
      return;
    } else {
      dispatch(removeValidationError("Lab Test Quantity"));
    }

    dispatch(
      handleAddLabTest({
        type: "ADDLABTEST",
        payload: {
          id: crypto.randomUUID(),
          lab_test_code: watch("lab_test_code"),
          quantity: watch("quantity"),
        },
      }),
    );

    setValue("lab_test_code", null);
    setValue("quantity", "");
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (deleteId) {
      dispatch(handleDeleteLabTest({ id: deleteId }));
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const getDiagnosisPractitioners = (diagnosisCode) => {
    const service = payloadService.find((s) => s.diag?.includes(diagnosisCode));
    if (!service || !service.pract) return null;
    const practitioner = practitionerListAdded.find(
      (p) => p.practitioner?.value?.practitioner_id === service.pract[0],
    )?.practitioner;
    return practitioner;
  };

  const isInstitutional =
    viewClaimInfo?.claim_type?.toLowerCase() === "institutional";

  const viewDiagnosisColumns = [
    {
      name: "#",
      selector: (_, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row.date || "-",
      width: "100px",
      wrap: true,
    },
    {
      name: "Type",
      selector: (row) => row.type || "-",
    },
    {
      name: "Condition Onset",
      selector: (row) => {
        const rawCode = String(row.condition_onset || "").toUpperCase();
        return conditionOnsetList.includes(rawCode) ? rawCode : "NR";
      },
    },
    ...(isInstitutional
      ? [
          {
            name: "On Admission",
            selector: (row) => {
              const option = onAdmissionOptions.find(
                (opt) => opt.value === row.onAdmission,
              );
              return option?.label || row.onAdmission || "-";
            },
          },
        ]
      : []),
    {
      name: "Diagnosis Info",
      selector: (row) => `(${row.code}) - ${row.description}`,
      wrap: true,
    },
    {
      name: "Practitioner",
      selector: (row) => {
        const practitioner = getDiagnosisPractitioners(row.code);
        return practitioner?.pract_name || "N/A";
      },
      wrap: true,
    },
  ];

  const diagnosisColumns = [
    {
      name: "#",
      selector: (_, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Date",
      selector: (row) => row.date || "-",
      width: "100px",
      wrap: true,
    },
    {
      name: "Type",
      cell: (row) => (
        <Form.Select
          value={row.type || ""}
          size="sm"
          onChange={(e) => handleFieldChange(e.target.value, row.id, "type")}
        >
          <option value="">Select Type</option>
          {diagnosisiList.map((type) => (
            <option key={type.diagtype_code} value={type.diagtype_code}>
              {type.diagtype_name}
            </option>
          ))}
        </Form.Select>
      ),
    },
    {
      name: "Condition Onset",
      cell: (row) => (
        <Form.Select
          value={row.condition_onset || ""}
          size="sm"
          onChange={(e) =>
            handleFieldChange(e.target.value, row.id, "condition_onset")
          }
        >
          <option value="">Select Type</option>
          {conditionOnset.map((type) => (
            <option key={type.condonset_code} value={type.condonset_code}>
              {type.condonset_name}
            </option>
          ))}
        </Form.Select>
      ),
    },
    ...(isInstitutional
      ? [
          {
            name: "On Admission",
            cell: (row) => (
              <Form.Select
                value={row.onAdmission || ""}
                size="sm"
                onChange={(e) =>
                  handleFieldChange(e.target.value, row.id, "onAdmission")
                }
              >
                <option value="">Select</option>
                {onAdmissionOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            ),
          },
        ]
      : []),
    {
      name: "Diagnosis Info",
      selector: (row) => `(${row.code}) - ${row.description}`,
      wrap: true,
    },
    {
      name: "Practitioner",
      selector: (row) => {
        const practitioner = getDiagnosisPractitioners(row.code);
        return practitioner?.pract_name || "N/A";
      },
      wrap: true,
    },
    {
      name: "Actions",
      button: true,
      cell: (row) =>
        isDisabled && (
          <Trash
            size={16}
            className="cursor-pointer text-danger"
            onClick={() => deleteDiagnosis(row)}
          />
        ),
    },
  ];

  const morphologyColumns = [
    {
      name: "Code",
      selector: (row) => row.morphology_code || "-",
      width: "120px",
    },
    {
      name: "Description",
      selector: (row) => row.morphology_shdescription || "-",
      wrap: true,
    },
  ];

  const labTestColumns = [
    {
      name: "#",
      selector: (_, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Lab Code",
      selector: (row) => row.lab_test_code?.loinc_code || "-",
    },
    {
      name: "Test Name",
      selector: (row) => row.lab_test_code?.loinc_description || "-",
    },
    {
      name: "LOINC UOM",
      selector: (row) => row.lab_test_code?.loinc_uom || "-",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity || "-",
    },
    {
      name: "Action",
      button: true,
      cell: (row) => (
        <IconButton
          size="sm"
          variant="danger"
          onClick={() => handleDeleteClick(row.id)}
        >
          <Trash size={15} />
        </IconButton>
      ),
    },
  ];

  const viewLabTestColumns = [
    {
      name: "#",
      selector: (_, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Lab Code",
      selector: (row) => row.lab_test_code?.loinc_code || "-",
    },
    {
      name: "Test Name",
      selector: (row) => row.lab_test_code?.loinc_description || "-",
    },
    {
      name: "LOINC UOM",
      selector: (row) => row.lab_test_code?.loinc_uom || "-",
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity || "-",
    },
  ];

  return (
    <div>
      <div>
        <Card.Header className="d-flex badge-subtle-success justify-content-between border-success align-items-center  border-bottom">
          <strong className="text-success fw-bold fs-12">
            <Clipboard2Pulse className="me-2" />
            Diagnosis Details
          </strong>
          {isDisabled && Number(claimsSetting?.submit) === 1 && (
            <PencilSquare
              size={12}
              className="text-success"
              role="button"
              onClick={() => setShowDiagnosisModal(true)}
            />
          )}
        </Card.Header>
        <Card.Body className="p-2">
          <div className="d-flex gap-2 align-items-center">
            <span className="fs-11 text-800 fw-bold">Accident?</span>
            <p className="fs-12 text-600 fw-normal mb-0">
              {stepFormData?.accident ? "Yes" : "No"}
            </p>
          </div>

          {stepFormData?.accident && (
            <Row className="mt-2 g-2">
              <Col md={6} lg={4} xl={3}>
                <h5 className="fs-12 text-800 fw-bold mb-1">Accident Date</h5>
                <p className="fs-12 text-600 mb-0">
                  {stepFormData?.accident_date
                    ? moment(stepFormData?.accident_date).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </Col>
              <Col md={6} lg={4} xl={3}>
                <h5 className="fs-12 text-800 fw-bold mb-1">Accident Type</h5>
                <p className="fs-12 text-600 mb-0">
                  {stepFormData?.accident_type?.accdnttype_name || "-"}
                </p>
              </Col>
              <Col xs={12} sm={6}>
                <h5 className="fs-12 fw-bold text-800 mb-1">Address</h5>
                <p className="fs-12 text-600 mb-0">
                  {`${stepFormData?.address || ""} ${
                    stepFormData?.street_name || ""
                  } ${stepFormData?.city || ""} ${stepFormData?.country || ""}`}
                </p>
              </Col>
            </Row>
          )}

          {preauthorizationDiagnosis.length > 0 ? (
            <>
              <span className="fs-11 text-800 mb-3 fw-bold">Diagnosis</span>

              {/* Simulated Table Header */}
              <div className="px-3 py-2 rounded border mt-2 border-primary mb-2">
                <Row className="fw-bold fs-13 text-800 text-uppercase">
                  <Col xs={6} md={2}>
                    Type
                  </Col>
                  <Col xs={12} md={5}>
                    Code / Description
                  </Col>
                  <Col xs={6} md={2}>
                    On Admission
                  </Col>
                  <Col xs={6} md={3}>
                    Condition Onset
                  </Col>
                </Row>

                {/* Diagnosis Rows */}
                <div>
                  {preauthorizationDiagnosis?.map((item, index) => (
                    <Row className="fs-12 text-600 mb-1">
                      <Col xs={6} md={2}>
                        {item?.type || "-"}
                      </Col>
                      <Col xs={12} md={5}>
                        {item?.code
                          ? `(${item.code}) - ${item.description}`
                          : "-"}
                      </Col>
                      <Col xs={6} md={2}>
                        {item?.onAdmission || "-"}
                      </Col>
                      <Col xs={6} md={3}>
                        {conditionOnset.find(
                          (onset) =>
                            onset?.condonset_code == item?.condition_onset,
                        )?.condonset_name || "-"}
                      </Col>
                    </Row>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="text-center fs-11 py-3 text-muted">
              No diagnosis information available
            </div>
          )}

          {morphologyData && (
            <>
              <div className="d-flex flex-column">
                <span className="fs-12 text-success fw-bold">Morpholgy </span>
                <span className="fs-12 fw-normal text-600">
                  {`(${morphologyData?.morphology_code}) - ${morphologyData?.morphology_shdescription}`}
                </span>
              </div>
            </>
          )}
          {labTestList.length > 0 && (
            <>
              <span className="fs-11 mb-3 text-success">Lab Test</span>

              {/* Simulated Table Header */}
              <Card className="px-3 py-2 mt-2 border border-primary mb-2">
                <Row className="fw-bold fs-12 text-800 text-uppercase">
                  <Col xs={6} md={2}>
                    Code
                  </Col>
                  <Col xs={6} md={6}>
                    Description
                  </Col>
                  <Col xs={6} md={2}>
                    UOM
                  </Col>
                  <Col xs={6} md={2}>
                    Qty
                  </Col>
                </Row>

                {/* Lab Test Rows */}
                <div>
                  {labTestList?.map((item, index) => (
                    <Row className="fs-12 text-600">
                      <Col xs={6} md={2}>
                        {item?.lab_test_code?.loinc_code || "-"}
                      </Col>
                      <Col xs={6} md={6}>
                        {item?.lab_test_code?.loinc_description || "-"}
                      </Col>
                      <Col xs={6} md={2}>
                        {item?.lab_test_code?.loinc_uom || "-"}
                      </Col>
                      <Col xs={6} md={2}>
                        {item?.quantity || "-"}
                      </Col>
                    </Row>
                  ))}
                </div>
              </Card>
            </>
          )}
        </Card.Body>
      </div>

      <EditDiagnosisModal
        show={showDiagnosisModal}
        onHide={() => setShowDiagnosisModal(false)}
      />

      <WizardModal
        modal={showTypeError}
        setModal={() => setShowTypeError(false)}
        title="Type Error"
        description="This Type can't be Principal"
      />
      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this lab test?"
      />
    </div>
  );
};

ClaimDiagnosisRequest.defaultProps = {
  data: {
    accident: false,
    accidentData: {
      date: "",
      type: "",
      address: "",
      street_name: "",
      city: "",
      country: "",
    },
    diagnosisData: [],
  },
  currentStep: {},
  age: { years: 0, months: 0, days: 0 },
};

export default ClaimDiagnosisRequest;
